module.exports = __webpack_public_path__ + "img/file-earmark-arrow-up.5e811f25.svg";